import { useTranslations } from '@aikoa/i18n/react'
import { Slot, useGlobalSearchParams } from 'expo-router'
import ContentBox from '~/components/layout/ContentBox'
import { LoadingView } from '~/components/LoadingView'
import { ButtonLabel, LinkButton } from '~/components/ui/button'
import { Text } from '~/components/ui/text'
import { useAsset } from '~/data/assets/useAssets'

function PropertyViewLayout() {
  const { t } = useTranslations(['property', 'common'])
  const { assetId } = useGlobalSearchParams<{ assetId: string }>()
  const { asset, isLoading } = useAsset(assetId)

  return (
    <>
      {isLoading ? (
        <LoadingView />
      ) : !asset ? (
        <ContentBox contentContainerClassName="items-center justify-center gap-2 py-10">
          <Text className="font-semibold text-lg">{t(($) => $.errors.notFound)}</Text>
          <Text className="text-center text-foreground">
            {t(($) => $.errors.notFoundDescription)}
          </Text>
          <LinkButton variant="primary" href="/" className="mt-6" size="lg">
            <ButtonLabel>{t(($) => $.actions.back)}</ButtonLabel>
          </LinkButton>
        </ContentBox>
      ) : (
        <Slot />
      )}
    </>
  )
}

export default PropertyViewLayout
